/* ==========================================================================
   Neodocs — theme interactions
   No dependencies. Everything degrades to working HTML without JS.
   ========================================================================== */
(function () {
  'use strict';

  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ----------------------------------------------------------------------
     Utilities
     ---------------------------------------------------------------------- */

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, event) {
    var items = $$(FOCUSABLE, container).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  var scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.body.classList.toggle('neo-no-scroll', scrollLocks > 0);
  }

  /* ----------------------------------------------------------------------
     Header: mega menu, search panel, sticky state
     ---------------------------------------------------------------------- */

  function initHeader(root) {
    var header = $('[data-neo-header]', root) || (root && root.matches && root.matches('[data-neo-header]') ? root : null);
    if (!header || header.dataset.neoReady === 'true') return;
    header.dataset.neoReady = 'true';

    var backdrop = $('[data-neo-backdrop]', header);
    var openTimer = null;
    var closeTimer = null;
    var openPanel = null;

    function panelFor(trigger) {
      var id = trigger.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function closeAll(immediate) {
      clearTimeout(openTimer);
      $$('[data-neo-menu-trigger]', header).forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      $$('.neo-mega, .neo-search, .neo-drop', header).forEach(function (p) {
        p.classList.remove('is-open');
      });
      if (backdrop) backdrop.classList.remove('is-open');
      openPanel = null;
      if (immediate) clearTimeout(closeTimer);
    }

    function open(trigger) {
      var panel = panelFor(trigger);
      if (!panel) return;
      clearTimeout(closeTimer);
      if (openPanel && openPanel !== panel) closeAll(true);
      trigger.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
      if (backdrop && panel.classList.contains('neo-mega')) backdrop.classList.add('is-open');
      openPanel = panel;
    }

    /* --- Mega menu triggers ------------------------------------------- */
    $$('[data-neo-menu-trigger]', header).forEach(function (trigger) {
      var panel = panelFor(trigger);
      if (!panel) return;

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (trigger.getAttribute('aria-expanded') === 'true') {
          closeAll(true);
        } else {
          open(trigger);
        }
      });

      if (trigger.dataset.neoMenuTrigger === 'hover') {
        var enter = function () {
          if (!mqDesktop.matches) return;
          clearTimeout(closeTimer);
          openTimer = setTimeout(function () {
            open(trigger);
          }, 90);
        };
        var leave = function () {
          if (!mqDesktop.matches) return;
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () {
            closeAll(true);
          }, 220);
        };

        [trigger, panel].forEach(function (el) {
          el.addEventListener('mouseenter', enter);
          el.addEventListener('mouseleave', leave);
        });
      }
    });

    /* --- Search panel -------------------------------------------------- */
    $$('[data-neo-search-toggle]', header).forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var panel = panelFor(toggle);
        if (!panel) return;
        var isOpen = panel.classList.contains('is-open');
        closeAll(true);
        if (!isOpen) {
          open(toggle);
          var input = $('input[type="search"]', panel);
          if (input) setTimeout(function () { input.focus(); }, 120);
        }
      });
    });

    /* --- Dismissal ----------------------------------------------------- */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !openPanel) return;
      var trigger = $('[aria-expanded="true"][aria-controls]', header);
      closeAll(true);
      if (trigger) trigger.focus();
    });

    document.addEventListener('click', function (event) {
      if (!openPanel) return;
      if (header.contains(event.target)) return;
      closeAll(true);
    });

    header.addEventListener('focusout', function (event) {
      if (!openPanel) return;
      if (event.relatedTarget && header.contains(event.relatedTarget)) return;
      closeAll(true);
    });

    if (backdrop) backdrop.addEventListener('click', function () { closeAll(true); });

    /* --- Collection ↔ product panel switching -------------------------- */
    $$('[data-neo-mega]', header).forEach(function (mega) {
      var cats = $$('[data-neo-cat]', mega);
      if (!cats.length) return;

      function activate(key) {
        cats.forEach(function (c) {
          c.classList.toggle('is-active', c.dataset.neoCat === key);
        });
        $$('[data-neo-panel]', mega).forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.neoPanel === key);
        });
        $$('[data-neo-feature]', mega).forEach(function (f) {
          f.classList.toggle('is-active', f.dataset.neoFeature === key);
        });
      }

      cats.forEach(function (cat, index) {
        var key = cat.dataset.neoCat;
        cat.addEventListener('mouseenter', function () { activate(key); });
        cat.addEventListener('focus', function () { activate(key); });

        cat.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowDown') next = cats[index + 1] || cats[0];
          if (event.key === 'ArrowUp') next = cats[index - 1] || cats[cats.length - 1];
          if (!next) return;
          event.preventDefault();
          next.focus();
        });
      });
    });

    /* --- Sticky shadow ------------------------------------------------- */
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    var section = header.closest('.shopify-section') || header;
    section.parentNode.insertBefore(sentinel, section);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          header.classList.toggle('is-stuck', !entries[0].isIntersecting);
        },
        { threshold: 0 }
      ).observe(sentinel);
    }

    // Published so sticky page content can clear the header.
    var publishHeight = function () {
      document.documentElement.style.setProperty(
        '--neo-header-height',
        header.getBoundingClientRect().height + 'px'
      );
    };
    publishHeight();
    window.addEventListener('resize', publishHeight);
  }

  /* ----------------------------------------------------------------------
     Mobile drawer
     ---------------------------------------------------------------------- */

  function initDrawer(root) {
    var drawer = $('[data-neo-drawer]', root || document);
    if (!drawer || drawer.dataset.neoReady === 'true') return;
    drawer.dataset.neoReady = 'true';

    var panel = $('.neo-drawer__panel', drawer);
    var lastTrigger = null;

    function openDrawer(trigger) {
      lastTrigger = trigger || null;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      lockScroll(true);
      setTimeout(function () {
        var target = $('[data-neo-drawer-close]', drawer);
        if (target) target.focus();
      }, 60);
    }

    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.add('is-closing');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      drawer.classList.remove('is-closing');
      if (lastTrigger) lastTrigger.focus();
    }

    $$('[data-neo-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openDrawer(btn);
      });
    });

    $$('[data-neo-drawer-close]', drawer).forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    var overlay = $('.neo-drawer__overlay', drawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        closeDrawer();
      } else if (event.key === 'Tab' && panel) {
        trapFocus(panel, event);
      }
    });

    mqDesktop.addEventListener('change', function (event) {
      if (event.matches) closeDrawer();
    });
  }

  /* ----------------------------------------------------------------------
     Accordions (mobile nav + anywhere else)
     ---------------------------------------------------------------------- */

  function initAccordions(root) {
    $$('[data-neo-accordion]', root || document).forEach(function (toggle) {
      if (toggle.dataset.neoReady === 'true') return;
      toggle.dataset.neoReady = 'true';

      var target = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!target) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        target.classList.toggle('is-open', !expanded);
      });
    });
  }

  /* ----------------------------------------------------------------------
     Announcement rotator
     ---------------------------------------------------------------------- */

  function initAnnouncements(root) {
    $$('[data-neo-announcement]', root || document).forEach(function (bar) {
      if (bar.dataset.neoReady === 'true') return;
      bar.dataset.neoReady = 'true';

      var items = $$('.neo-announcement__item', bar);
      if (items.length < 2) return;

      var speed = parseInt(bar.dataset.neoSpeed, 10) || 5;
      var index = 0;
      var timer = null;

      function show(next) {
        items[index].classList.remove('is-active');
        index = (next + items.length) % items.length;
        items[index].classList.add('is-active');
      }

      function start() {
        stop();
        timer = setInterval(function () { show(index + 1); }, speed * 1000);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      start();
    });
  }

  /* ----------------------------------------------------------------------
     Reveal on scroll
     ---------------------------------------------------------------------- */

  var revealObserver = null;

  function initReveal(root) {
    var targets = $$('[data-neo-reveal]', root || document).filter(function (el) {
      return !el.classList.contains('neo-revealed');
    });
    if (!targets.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('neo-revealed'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('neo-revealed');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );
    }

    targets.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ----------------------------------------------------------------------
     Scroll carousels
     ---------------------------------------------------------------------- */

  function initCarousels(root) {
    $$('[data-neo-carousel]', root || document).forEach(function (carousel) {
      if (carousel.dataset.neoReady === 'true') return;
      carousel.dataset.neoReady = 'true';

      var track = $('[data-neo-carousel-track]', carousel);
      var prev = $('[data-neo-carousel-prev]', carousel);
      var next = $('[data-neo-carousel-next]', carousel);
      if (!track) return;

      function step() {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        var hasOverflow = track.scrollWidth > track.clientWidth + 4;
        var nav = $('[data-neo-carousel-nav]', carousel);
        if (nav) nav.hidden = !hasOverflow;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(sync);
      });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ----------------------------------------------------------------------
     Boot
     ---------------------------------------------------------------------- */

  function init(root) {
    initHeader(root);
    initDrawer(root);
    initAccordions(root);
    initAnnouncements(root);
    initCarousels(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-initialise sections as they are re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    init(event.target);
  });
})();
